import { z } from 'zod';

type NewSubscription = {
  isNew: boolean;
};

export type SubscriptionResponse = {
  id: string;
  organisationName: string;
  isActive: boolean;
  isIndigenousOwned: boolean;
  location: string;
  state: string;
  phone: string;
  email?: string;
  timezone: string;
  postcode: string;
  address: string;
  planId: string;
  renewalPeriod: string;
  logoUrl?: string;
  excludeEmail: number;
  autoDeliverableStatusUpdate: boolean;
  allowAddPrimaryFocusAreas: boolean;
  allowAddSecondaryFocusAreas: boolean;
  allowedDomains: string[];
  isAutoProvisionEnabled: boolean;
  primaryContactId?: string;
  ownerIds?: string[];
  isSocialFeedEnabled: boolean;
  isAISuggestionEnabled: boolean;
};

export type SubscriptionData = SubscriptionResponse | NewSubscription;

export interface IGroupDto {
  id: string;
  name: string;
}

export const subscriptionSearchSchema = z.object({
  tab: z.enum(['organisation', 'users', 'business-units', 'filter-labels']).default('organisation'),
  strategy: z.string().optional()
});
export type subscriptionItemFilters = z.infer<typeof subscriptionSearchSchema>;
